<template>
  <QuickLook :horizontal="horizontal" :yearlyValues="yearlyValues" :horizon="horizon"></QuickLook>
</template>

<script>
import AADashboardMixin from "@/mixins/AADashboard";
import { formatNumber } from "@/plugins/utils";

export default {
  mixins: [AADashboardMixin],
  name: "AAQuickLook",
  components: { QuickLook: () => import("@/components/dashboards/QuickLook.vue") },
  props: {
    caseOutputs: { type: Object, required: false, default: () => ({}) },
    inputCase: { type: Object, required: false, default: () => ({}) },
    horizontal: { type: Boolean, required: false, default: false },
  },
  data() {
    return {};
  },
  computed: {
    mapping() {
      return [
        {
          title: "Peak Demand",
          item: this.getOutput("peak_demand", this.output),
          format: 0,
          suffix: "MW",
        },
        {
          title: "Installed Capacity",
          item: this.getOutput("installed_capacity", this.output),
          format: 0,
          suffix: "MW",
        },
        {
          title: "Storage Capacity",
          item: this.storageQuickLook,
          format: 0,
          suffix: "MW",
        },
        {
          title: "Renewable Share",
          item: this.renewableShare,
          format: 2,
          suffix: "%",
        },
        {
          title: "Average Price",
          item: this.getOutput("zonal_price", this.output),
          format: 2,
          suffix: "$/MWh",
        },
        {
          title: "Total DR Capacity",
          item: this.getOutput((out) => out.demand_response[0].installed_capacity, this.output),
          format: 2,
          suffix: "MW",
        },
        {
          title: "Total EE Capacity",
          item: this.getOutput((out) => out.energy_efficiency[0].installed_capacity, this.output),
          format: 2,
          suffix: "MW",
        },
      ];
    },
    yearlyValues() {
      return this.simulationYearArray.map((year, i) => ({
        year,
        values: this.mapping.map((el) => ({
          title: el.title,
          suffix: el.suffix,
          value: formatNumber(el.item[i], el.format),
        })),
      }));
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    formatNumber,
  },
};
</script>

<style></style>
